import Listing from "../../Listing";
import React, { useEffect } from "react";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import HeroSection from "../../../../layout/HeroSection";
import Loader from "../../../../components/other/Loader";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonSlicing } from "../../../../redux/action/lessonsAction";
import SecureContent from "../../../../components/secureContent";

const Slicing = () => {
  const dispatch = useDispatch();
  const { slicingList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonSlicing());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Slicing"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            // {
            //   name: "3D Printing",
            //   path: pageRoutes?.lessons?.threeDModling,
            // },
            { name: "Slicing", path: `${pageRoutes?.home}/` },
          ]}
        />

        <Listing contentData={slicingList} />

        <Footer />
      </div>
    </>
  );
};

export default Slicing;
